import React from 'react';
import { ShieldCheck } from 'lucide-react';

const LABELS = { bank: 'اشتراك بنك العائلة', bank_amwali_plus: 'باقة أموالي +' };

export default function SubscriptionBadge({ sub, size = 'sm', showDays = false }) {
  const active = sub?.state === 'active' && Boolean(LABELS[sub?.type]);
  return <span data-testid="sub-badge" className={`inline-flex items-center gap-1 rounded-full border px-2 font-bold ${size === 'md' ? 'py-1 text-xs' : 'py-0.5 text-[10px]'} ${active ? 'border-[var(--c-gold)]/45 bg-[var(--c-gold)]/15 text-[var(--c-gold)]' : 'border-[var(--c-border)] bg-[var(--c-cream)] text-[var(--c-muted)]'}`}>
    {active && <ShieldCheck className="h-3 w-3" />}
    {active ? LABELS[sub.type] : 'بدون اشتراك'}
    {active && showDays && sub.days_left != null && <span className="font-normal">· {sub.days_left} يوم</span>}
  </span>;
}
